module.exports = __webpack_public_path__ + "static/media/multi_codec.291a9062.svg";